module.exports = __webpack_public_path__ + "static/partner-logo-netgroup-c22bf9c3376a8af91984936b8901dc31.png";